import domToImage from "dom-to-image";

export const captureElementsAsImages = async (elements) => {
    const images = [];

    for (const el of elements) {
        if (!el) continue;

        const img = await domToImage.toPng(el, { quality: 1 });
        images.push(img);
    }

    return images;
};